<template>
  <div class="filter-icon">
    <svg
      width="12"
      height="12"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1_2)">
        <path
          d="M5 20H3V17.7778H0V15.5555H3V13.3333H5V20ZM20 17.7778H7V15.5555H20V17.7778ZM15 13.3333H13V11.1111H0V8.88886H13V6.67998H15V13.3333ZM20 11.1111H17V8.88886H20V11.1111ZM9 6.66665H7V4.44443H0V2.22222H7V0H9V6.66665ZM20 4.44443H11V2.22222H20V4.44443Z"
          :fill="props.fill"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_2">
          <rect
            width="20"
            height="20"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>

<script setup>
defineOptions({
  name: 'IconsFilter'
})

const props = defineProps({
  fill: {
    type: String,
    default: semanticColorLookup('surface.on-surface')
  }
})
</script>